import React from 'react';
import styles from './NonCriticalErrorBanner.module.css';
import { useGlobalError } from '../../context/GlobalErrorContext';
import { useMetadata } from '../../context/MetadataContext';

const NonCriticalErrorBanner = () => {
  const { currentError, clearError } = useGlobalError();
  const { getText } = useMetadata();

  // Only show for non-critical errors
  if (!currentError || currentError.severity === 'critical') return null;

  // Get localized message for user errors
  const getDisplayMessage = () => {
    if (currentError.type === 'user' && currentError.errorCode) {
      // Try to get localized message from errors section
      const localizedMessage = getText(`errors.${currentError.errorCode}`);
      
      // Return localized message if found, otherwise fallback to error code
      return localizedMessage !== `errors.${currentError.errorCode}` ? localizedMessage : currentError.errorCode;
    }
    
    // For system errors, use the message directly
    return currentError.message;
  };
  
  const displayMessage = getDisplayMessage();

  return (
    <div className={styles.banner} role="alert">
      <span className={styles.message}>{displayMessage}</span>
      <button className={styles.closeButton} aria-label="Dismiss error" onClick={clearError}>
        ×
      </button>
    </div>
  );
};

export default NonCriticalErrorBanner;
